"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Level;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("./level.scss");

function Level(props) {
  // the idea for this is similar to a bulma level
  var left = props.left,
      right = props.right,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      rest = (0, _objectWithoutProperties2["default"])(props, ["left", "right", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({
    className: "nstyle__level ".concat(className)
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__left"
  }, left), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle__right"
  }, right));
}